"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5zM5.5 5a.5.5 0 0 0-.5.5V9h4V5zM10 5v4h9V5.5a.5.5 0 0 0-.5-.5zm-1 5H5v8.5a.5.5 0 0 0 .5.5H9zm1 9h8.5a.5.5 0 0 0 .5-.5V10h-9z"
}), 'Excel');
//# sourceMappingURL=index.js.map